import React from 'react';
import { getCustomHeadingsLabel, translateHeading, headingsMap } from '../heading/utils.js';
import '../utils.js';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';

const getCurrentHeadingIcon = (allowHeadingCustomization) => (editorCommands, t) => {
  const selectedHeading = editorCommands.getCurrentHeading();
  let Label;
  if (allowHeadingCustomization) {
    Label = getCustomHeadingsLabel(selectedHeading, t, editorCommands);
  } else {
    Label = translateHeading(headingsMap[selectedHeading], t);
  }
  return () => /* @__PURE__ */ React.createElement("div", null, Label);
};

export { getCurrentHeadingIcon };
//# sourceMappingURL=getCurrentHeadingIcon.js.map
